import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

const LoadingState: React.FC = () => {
  useUiLanguage();
  return (
    <Card>
      <CardContent className="flex items-center justify-center py-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-900 mx-auto mb-4"></div>
          <p>{uiText("Loading belt requirements...")}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default LoadingState;
